import template from './template.html'
import Controller from './tabBar.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    activeTab: '=',
    storyObj: '=',
  },
  controllerAs: 'vm',
  controller: Controller,
}
